import { Stack, Typography } from "@mui/material";
import { AppRoutes, UploadMethodsOption } from "../../../../../types/enums";
import { Link } from "react-router-dom";

type Props = {
  method: UploadMethodsOption;
};

export const DataUploadHeaderBlock = ({ method }: Props) => {
  const headerMapper = {
    [UploadMethodsOption.crm]: (
      <Typography
        variant="body2"
        color="custom.textDarkBlue"
        sx={{
          border: "1px solid #FFD5A1",
          backgroundColor: "#FFF7E5",
          borderRadius: "6px",
          padding: "16px",
        }}
      >
        Log in and select the list you would like to sync. Check{" "}
        <Link
          to={AppRoutes.CAMPAIGNS_REQUIREMENTS}
          style={{ color: "inherit" }}
          target="_blank"
        >
          Field Requirements
        </Link>{" "}
        page for import details.
      </Typography>
    ),
    [UploadMethodsOption.desktop]: (
      <Typography
        variant="body2"
        color="custom.textDarkBlue"
        sx={{
          border: "1px solid #FFD5A1",
          backgroundColor: "#FFF7E5",
          borderRadius: "6px",
          padding: "16px",
        }}
      >
        Check the{" "}
        <Link
          to={AppRoutes.CAMPAIGNS_REQUIREMENTS}
          style={{ color: "inherit" }}
          target="_blank"
        >
          Field Requirements
        </Link>{" "}
        page with accounts and contacts fields to be imported.
      </Typography>
    ),
    [UploadMethodsOption.manually]: (
      <Typography
        variant="body2"
        color="custom.textDarkBlue"
        sx={{
          border: "1px solid #FFD5A1",
          backgroundColor: "#FFF7E5",
          borderRadius: "6px",
          padding: "16px",
        }}
      >
        Add target accounts names to search for buying committee and get roles
        segmentation insights.
      </Typography>
    ),
    [UploadMethodsOption.cid]: (
      <Stack
        sx={{
          border: "1px solid #FFD5A1",
          backgroundColor: "#FFF7E5",
          borderRadius: "6px",
          padding: "16px",
        }}
      >
        <Typography component="span" variant="body1" color="text.secondary">
          Provide your CID to retrieve accounts and leads data.
        </Typography>
        <Typography component="span" variant="body1" color="text.secondary">
          If your campaign uses multiple goals, you can optionally add a Sub-CID
          to pull leads for a specific objective.
        </Typography>
      </Stack>
    ),
  };

  return method ? headerMapper[method] : null;
};
